import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CheckboxListData } from "@layouts/filterLayout";

interface SelectedFilterProps {
  count: number;
  selectedItems: string[][];
  traitsData: CheckboxListData[];
  totalCount: number;
  onClickClearAll: () => void;
  onClickRemoveItem: (rowIndex: number, colIndex: number) => void;
}

const SelectedFilter = ({ selectedItems, traitsData, count, totalCount, onClickClearAll, onClickRemoveItem }: SelectedFilterProps) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center', lg: 'center' }}
      sx={{
        marginX: { xs: "10px", sm: "10px", lg: "55px" },
        marginTop: "18px",
        width: 'auto',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Typography
        sx={{ fontSize: "12px", fontWeight: "700", color: "#868B93", whiteSpace: 'nowrap' }}
      >{`${totalCount} ${[1, 0]?.includes(totalCount) ? 'ITEM' : 'ITEMS'}`}</Typography>
      <Stack direction="row" spacing={ 0.3 } sx={{ flexWrap: { xs: 'nowrap', sm: 'nowrap', md: 'wrap' }, rowGap: '12px' }}>
        {selectedItems?.map((item, rowIndex: number) => {
          return (
            <Box sx={{ display: "flex", gap: "8px" }} key={ rowIndex }>
              { item?.map((res, columnIndex) => {
                return (
                  <Box
                    key={ columnIndex }
                    onClick={ () => onClickRemoveItem(rowIndex, columnIndex) }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      padding: "4px 8px",
                      borderRadius: "50px",
                      background: "#E0E0E0",
                      height: "30px",
                      cursor: "pointer",
                    }}
                  >
                    <Typography
                      sx={{ fontSize: "12px", fontWeight: "500", color: "#616161", whiteSpace: 'nowrap !important' }}
                    >
                      {res === 'false' ? 'Not Claimed' : res === 'true' ? 'Claimed' : traitsData[rowIndex]?.type == 'Number' ? `${ traitsData[rowIndex]?.label } : ${ res }` : res}
                    </Typography>
                    <CloseIcon sx={{ fontSize: "14px" }} />
                  </Box>
                )
              }) }
            </Box>
          );
        })}
        { count > 0 && (
          <Button
            size="small"
            onClick={ onClickClearAll }
            sx={{
              borderRadius: "50px",
              height: "30px",
              background: "#FEE3E5",
              color: "#CE2818",
              textTransform: "none",
              fontSize: "12px",
            }}
          >
            Clear all
          </Button>
        ) }
      </Stack>
    </Stack>
  );
};

export default SelectedFilter;
